import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=76676b9c&scoped=true&"
var script = {}
import style0 from "./Copyright.vue?vue&type=style&index=0&id=76676b9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76676b9c",
  null
  
)

export default component.exports